export { mergeStyles, mergeCss } from './mergeStyles';
export { mergeStyleSets, mergeCssSets } from './mergeStyleSets';
export { concatStyleSets } from './concatStyleSets';
export { concatStyleSetsWithProps } from './concatStyleSetsWithProps';
export { fontFace } from './fontFace';
export { keyframes } from './keyframes';
export * from './Stylesheet';
export { setRTL } from './StyleOptionsState';
import './version';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /home/travis/build/proofdict/proofdict/node_modules/@uifabric/merge-styles/lib/index.js
// module id = 12
// module chunks = 0